module.exports = __webpack_public_path__ + "static/media/rotaPlane.500f937b.svg";